import { ProfileFormData } from "./ProfileFormData";

export class SecondaryEducationFormData extends ProfileFormData {
    constructor(_applicantId: number, _pageId: string) {
        super(_applicantId, _pageId);
    }
    Id?: number;
    // Education type and institution details
    EducationType?: string;
    InstitutionName?: string;

    /**
     * dbo.AmHighSchool_VW.AMHighSchoolID for the selected school, the counterpart of AmCollegeId on the
     * post-secondary side. Serialised as amHighSchoolId, which is what
     * HighSchoolInformation.AmHighSchoolId binds and what HighSchoolInformationHandler forwards to Nexus
     * as HighSchoolId. Undefined when the applicant typed a school that is not in the catalog.
     */
    AmHighSchoolId?: number;
    
    // Address information
    Country?: string;
    StreetAddress?: string;
    AddressLine2?: string;
    City?: string;
    State?: string;
    PostalCode?: string;
    PhoneNumber?: string;
    
    // Student information
    NameWhileEnrolled?: string;
    CompletionDate?: string;
    GraduationDate?: string;

    /**
     * Declared because toJSON() already serialises it. It was being sent as `GPA: this.GPA` against a
     * property that did not exist, which TypeScript flagged (TS2339) and which meant the key always
     * went over the wire as undefined. The server side is ready for it -- HighSchoolInformation has
     * [JsonPropertyName("gpa")] double? GPA -- but nothing in the form collects a value yet, so this
     * only stops the field being silently impossible to populate.
     */
    GPA?: number;
    
    // Additional fields
    HomeSchoolAgencySponsor?: string;
    HomeSchoolSchoolDistrict?: string;

    toJSON() {
        return {
            applicantId: this.applicantId,
            pageId: this.pageId,
            Id: this.Id,
            EducationType: this.EducationType,
            InstitutionName: this.InstitutionName,
            amHighSchoolId: this.AmHighSchoolId,
            Country: this.Country,
            StreetAddress: this.StreetAddress,
            AddressLine2: this.AddressLine2,
            City: this.City,
            State: this.State,
            PostalCode: this.PostalCode,
            PhoneNumber: this.PhoneNumber,
            NameWhileEnrolled: this.NameWhileEnrolled,
            CompletionDate: this.CompletionDate,
            GraduationDate: this.GraduationDate,
            GPA: this.GPA,
            HomeSchoolAgencySponsor: this.HomeSchoolAgencySponsor,
            HomeSchoolSchoolDistrict: this.HomeSchoolSchoolDistrict
        };
    }
}
